export const columns = function () {
	return [
		{
			prop: "title",
			label: "标题",
			minWidth: 50,
		},
		{
			prop: "mark",
			label: "备注",
			minWidth: 50,
		},
		{
			prop: "create_time",
			label: "创建时间",
			minWidth: 30,
		},
		{
			prop: "handle",
			label: "操作",
			minWidth: 30,
		},

	]
}

// 表单相关
export const formOption = function () {
	return [
		{
			prop: "title",
			label: "标题",
			placeholder: '请输入标题',
			type: "input",
			width: "20%"
		},
		{
			prop: "mark",
			label: "备注",
			placeholder: '请输入备注',
			type: "input",
			width: "20%"
		},
		{
			prop: "content",
			label: "合同内容一",
			type: "editor",
			width: "20%",
		},
		{
			prop: "content_two",
			label: "合同内容二",
			type: "editor",
			width: "20%",
		},
		// {
		//  prop: "content_three",
		//  label: "合同内容三",
		//  type: "editor",
		//  width: "20%",
		// }
	]
}

/**
 * 校验相关 
 */
export const rules = function (self) {
	return {
		title: [
			{ required: true, message: '请输入标题', trigger: ['change', 'blur'] }
		],
		content: [
			{ required: true, message: '请填写合同内容一', trigger: ['change', 'blur'] }
		],
		content_two: [
			{ required: true, message: '请填写合同内容二', trigger: ['change', 'blur'] }
		],
		// content_three: [
		//   { required: true, message: '请填写合同内容三', trigger: ['change', 'blur']}
		// ],
	}
}

export default {}